








































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, watch, onMounted, onBeforeUnmount, ref } from '@vue/composition-api';
import jsZip from "jszip";
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import AnswerImageArea from "../../components/AnswerImageArea.vue";
import PreviewImageArea from "../../components/PreviewImageArea.vue";
import MovieContentArea from "../../components/MovieContentArea.vue";
import PreviewHeaderLeftArea from "../../components/PreviewHeaderLeftArea.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import KaitouToolbarVertical from "../../components/KaitouToolbarVertical.vue";
import KaitouToolbarHorizon from "../../components/KaitouToolbarHorizon.vue";
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import { BToast } from 'bootstrap-vue';
import { BaseSheet, BaseSheetField, PageItem, DirectionEnum, AnswerText, ParamBaseSheetField, CurrentModeEnum, AnswerImage, QuestionImageDiscription, RejectionStudentSheetLog,  MovieContent, StudentMovieContent } from "../../modules/student/DigitalReport"
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import heic2any from "heic2any";

const PreviewImageTypeEnum = Common.PreviewImageTypeEnum;

export interface Data {
  initiarizedData: boolean
  student_sheet_id: string
  status: number
  times: number
  base_sheet: BaseSheet
  subject_name: string
  pageItems: PageItem[]
  base64QuestionImages: string[]
  DirectionEnum: Readonly<{Horizon: number; Vertical: number;}>
  direction: number
  selectedFieldIdx: number
  fieldMargin: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  selectedAnswerPageIdx: number
  selectedQuestionPageIdx: number
  selectedCorrectPageIdx: number
  selectedStamp: any
  drawMode: number
  drawModeCache: number
  drawColor: string
  thickness: number
  fontSize: number
  lineHeight: number
  textColor: string
  choiceAreaLeft: number
  choiceAreaTop: number
  modeAreaLeft: number
  modeAreaTop: number
  pointerOffsetX: number
  pointerOffsetY: number
  isDragging: boolean
  before_student_sheet_id: number
  keyCode: string
  isShortcutKeyEnable: boolean
  pcHelpFields: any[]
  tabletHelpFields: any[]
  errors: string[]
  remainingTime: number
  isRemainingTimeDisp: boolean
  timer: any
  isTimeOver: boolean
  isTimeOverAlertDisp: boolean
  scored_user_name: string
  CurrentModeEnum: Readonly<{Answer: number; SelfScoring: number; Preview: number;}>
  currentMode: number
  isParent: boolean
  questionImageDiscriptions: QuestionImageDiscription[]
  rejectionStudentSheetLog: RejectionStudentSheetLog
  previewImageType: number
  toolbarPosition: number
  isScrolling: boolean
  movieContents: MovieContent[]
  isDispMovieArea: boolean
  movieAreaTop: number
  movieAreaLeft: number
  movieAreaWidth: number
  movieAreaHeight: number
  previewImateTypes: number[]
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "answer-image-area": AnswerImageArea,
    "preview-image-area": PreviewImageArea,
    "movie-content-area": MovieContentArea,
    "preview-header-left-area": PreviewHeaderLeftArea,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "v-swatches": VSwatches,
    "text-direction-toggle": TextDirectionToggle,
    "text-edit-box": TextEditBox,
    "kaitou-toolbar-vertical": KaitouToolbarVertical,
    "kaitou-toolbar-horizon": KaitouToolbarHorizon
  },
  setup(props, context){

    const horizonAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const verticalAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const horizonQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const horizonCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const saveCompletedToastRef = ref<InstanceType<typeof BToast>>();
    const textEditBoxRef = ref<InstanceType<typeof TextEditBox>>();

    const AnswerTypeEnum = Common.AnswerTypeEnum;
    const StmapTypeEnum = Common.StmapTypeEnum;
    const ToolbarPositionEnum = Common.ToolbarPositionEnum;

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      initiarizedData: false,
      student_sheet_id: null,
      status: null,
      times: null,
      base_sheet: null,
      subject_name: null,
      pageItems: [],
      base64QuestionImages: [],
      DirectionEnum: DirectionEnum,
      direction: DirectionEnum.Vertical,
      selectedFieldIdx: null,
      fieldMargin: 50,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.5,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.5,
      separatorSize: 10,
      selectedAnswerPageIdx: 0,
      selectedQuestionPageIdx: 0,
      selectedCorrectPageIdx: 0,
      selectedStamp: null,
      drawMode: Common.DrawModeEnum.None,
      drawModeCache: Common.DrawModeEnum.None,
      drawColor: "#000000",
      thickness: 2,
      fontSize: 32,
      lineHeight: 0,
      textColor: "#000000",
      choiceAreaLeft: 0,
      choiceAreaTop: 0,
      modeAreaLeft: 0,
      modeAreaTop: 0,
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isDragging: false,
      before_student_sheet_id: null,
      keyCode: null,
      isShortcutKeyEnable: true,
      pcHelpFields: [],
      tabletHelpFields: [
        { key: "設問青枠内を長押し", description: "長押しした場所にテキストを出力" },
        { key: "テキストを長押し", description: "長押ししたテキストを削除" },
        { key: "問題用紙または解答用紙上でピンチイン・ピンチアウト", description: "用紙の拡大縮小<br>（手書きモードで設問青枠内では使用できません）" },
      ],
      errors: [],
      remainingTime: null,
      timer: null,
      isTimeOver: false,
      isRemainingTimeDisp: false,
      isTimeOverAlertDisp: false,
      scored_user_name: null,
      CurrentModeEnum: CurrentModeEnum,
      currentMode: null,
      isParent: context.root.$store.state.is_parent,
      questionImageDiscriptions: [],
      rejectionStudentSheetLog: null,
      previewImageType: PreviewImageTypeEnum.None,
      toolbarPosition: context.root.$store.state.kaitouToolbarPosition,
      isScrolling: false,
      movieContents: [],
      isDispMovieArea: false,
      movieAreaTop: 0,
      movieAreaLeft: 0,
      movieAreaWidth: 0,
      movieAreaHeight: 0,
      previewImateTypes: [],
    });

    const DrawModeEnum = Common.DrawModeEnum;

    /************************************************************
     * 採点結果PDF表示
     ************************************************************/

    const downloadResultPdf = async () => {
      context.root.$store.dispatch("showOverlay");
      
      await http.get(`/api/student/student_sheet_list/download_result_pdf/${state.before_student_sheet_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * メインエリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");

      if(!mainArea){
        return;
      }
      
      const toolbarFooterArea = document.getElementById(`toolbar-area-${ToolbarPositionEnum.Bottom}`);
      const toolbarFooterHeight = toolbarFooterArea ? toolbarFooterArea.clientHeight : 0;

      let toolbarSideWidth = 0;
      
      const toolbarLeftArea = document.getElementById(`toolbar-area-${ToolbarPositionEnum.Left}`);
      toolbarSideWidth += toolbarLeftArea ? toolbarLeftArea.clientWidth : 0;

      const toolbarRightArea = document.getElementById(`toolbar-area-${ToolbarPositionEnum.Right}`);
      toolbarSideWidth += toolbarRightArea ? toolbarRightArea.clientWidth : 0;

      state.mainAreaHeight = windowHeight - mainArea.offsetTop - toolbarFooterHeight;
      state.mainAreaWidth = windowWidth - toolbarSideWidth;

      // ツールバー表示によりmainAreaがd-flexになったためコメントアウト
      // mainArea.style.width = state.mainAreaWidth + "px";
      
      mainArea.style.height = state.mainAreaHeight + "px";
      state.modeAreaTop = (mainArea.offsetTop + 56);
      state.modeAreaLeft = state.mainAreaWidth - modeAreaWidth.value - 20;
    };

    /************************************************************
     * 問題用紙・解答用紙を画面内に収まるようにリサイズ
     ************************************************************/

    const adjustSheet = () => {
      const questionArea = document.getElementById(`question-page-root-${state.direction}-${state.base_sheet.sheet_type}`);
      const correctArea = document.getElementById(`correct-page-root-${state.direction}-${state.base_sheet.sheet_type}`);
      const answerArea = document.getElementById(`answer-page-root-${state.direction}-${state.base_sheet.sheet_type}`);
      const answerAreaHeader = document.getElementById(`answer-area-header-${state.direction}-${state.base_sheet.sheet_type}`);
      const mainArea = document.getElementById("main-area");

      if(questionArea && mainArea){
        const areaW = questionArea.clientWidth - 16;
        const areaH = mainArea.clientHeight - 80;
        
        const scaleW = areaW / state.base_sheet.questionImageWidth;
        const scaleH = areaH / state.base_sheet.questionImageHeight;
        const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
        verticalQuestionImageAreaRef.value.inputScale = scale;
        horizonQuestionImageAreaRef.value.inputScale = scale;
      }

      if(correctArea && mainArea){
          const areaW = correctArea.clientWidth - 16;
          const areaH = mainArea.clientHeight - 80;
          
          const scaleW = areaW / state.base_sheet.width;
          const scaleH = areaH / state.base_sheet.height;
          const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
          verticalCorrectImageAreaRef.value.inputScale = scale;
          horizonCorrectImageAreaRef.value.inputScale = scale;
        }

      if(answerArea && answerAreaHeader && mainArea){
        const areaW = answerArea.clientWidth - 16;
        const areaH = mainArea.clientHeight - 80;
        
        const scaleW = areaW / state.pageItems[state.selectedAnswerPageIdx].base_width;
        const scaleH = areaH / state.pageItems[state.selectedAnswerPageIdx].base_height;
        const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

        verticalAnswerImageAreaRef.value.inputScale = scale;
        horizonAnswerImageAreaRef.value.inputScale = scale;
      }
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
    }

    /************************************************************
     * 横向きモードの上部エリアのheight
     ************************************************************/

    const horizonModeTopHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonTopHeightPer;
    });

    /************************************************************
     * 横向きモードの下部エリアのheight
     ************************************************************/

    const horizonModeBottomHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonBottomHeightPer;
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
        state.selectedStamp = null;

        context.root.$nextTick(() => {
          if(state.direction == DirectionEnum.Horizon){
            horizonAnswerImageAreaRef.value.renderCanvas();
          }else{
            verticalAnswerImageAreaRef.value.renderCanvas();
          }
        });
      }
    }

    /******************************
     * 解答用紙ページ切り替え時のemit
     ******************************/

    const answerSheetPageChanged = (idx: number) => {
      state.selectedAnswerPageIdx = idx;
      changeSelectedBaseSheetField(0);
    }

    /******************************
     * 問題用紙ページ切り替え時のemit
     ******************************/

    const questionSheetPageChanged = (idx: number) => {
      state.selectedQuestionPageIdx = idx;
    }

    /******************************
     * 模範解答ページ切り替え時のemit
     ******************************/

     const correctImagePageChanged = (idx: number) => {
      state.selectedCorrectPageIdx = idx;
    }

    /******************************
     * 問題用紙・模範解答表示切り替え
     ******************************/

     const changeImageType = (imageType: number) => {
      state.previewImageType = imageType;
    }

    /******************************
     * 設問アイコンクリック時のemit
     ******************************/

    const changeSelectedBaseSheetField = async (selectedFieldIdx: number) => {

      // 設問切替前に現在の設問に空のテキストスタンプをを除外する
      if(selectedBaseSheetField.value && selectedBaseSheetField.value.answer_type != AnswerTypeEnum.Choice){
        selectedBaseSheetField.value.answer_texts = selectedBaseSheetField.value.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0);
      }

      state.selectedFieldIdx = selectedFieldIdx;
      state.selectedStamp = null;

      if(selectedBaseSheetField.value){

        // 設問切替後の初期状態を設定
        if(selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Both){
          // 解答方式が手書き・テキストの場合、最終操作キャッシュを元に判定
          if(state.drawModeCache == DrawModeEnum.Text){
            // 移動前の設問でテキスト出力していた場合
            if(selectedBaseSheetField.value.answer_texts.length > 0){
              // テキスト解答済みの設問の場合、出力済みスタンプを選択状態にする
              changeSelectedStamp(selectedBaseSheetField.value.answer_texts[0], true);
              state.drawMode = DrawModeEnum.None;
            }else if(selectedBaseSheetField.value.is_canvas_drawed){
              // テキスト0件、手書きで解答済みの設問の場合、自由線モードに切り替える
              state.drawMode = DrawModeEnum.FreeLine;
              state.drawModeCache = DrawModeEnum.FreeLine;
            }else{
              // テキスト出力0件・手書きもされていない未解答設問の場合は、テキストを出力
              addTextStampFieldCenter();
              state.drawMode = DrawModeEnum.None;
            }
          }else if(state.drawModeCache == DrawModeEnum.FreeLine){
            // 移動前の設問で手書きしていた場合
            if(!selectedBaseSheetField.value.is_canvas_drawed && selectedBaseSheetField.value.answer_texts.length > 0){
              // 移動後の設問に手書きなし、テキスト解答のみの場合、出力済みスタンプを選択状態にする
              changeSelectedStamp(selectedBaseSheetField.value.answer_texts[0], true);
              state.drawMode = DrawModeEnum.None;
            }else{
              // 上記以外は自由線モードに切り替える
              state.drawMode = DrawModeEnum.FreeLine;
              state.drawModeCache = DrawModeEnum.FreeLine;
            }
          }
        }else if(selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Text){
          if(selectedBaseSheetField.value.answer_texts.length > 0){
            // テキスト解答済みの設問の場合、出力済みスタンプを選択状態にする
            changeSelectedStamp(selectedBaseSheetField.value.answer_texts[0], true);
            state.drawMode = DrawModeEnum.None;
          }else{
            // テキスト出力0件・手書きもされていない未解答設問の場合は、テキストを出力
            addTextStampFieldCenter();
            state.drawMode = DrawModeEnum.None;
          }
        }else if(selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Draw){
          // 解答方式が手書きのみの場合、自由線モードに切り替える
          state.drawMode = DrawModeEnum.FreeLine;
          state.drawModeCache = DrawModeEnum.FreeLine;
        }else if(selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Image){
          // 解答方式が画像の場合、出力済み画像 or テキストスタンプを選択状態にする
          if(selectedBaseSheetField.value.answer_images.length > 0){
            changeSelectedStamp(selectedBaseSheetField.value.answer_images[0], false);
            state.drawMode = DrawModeEnum.None;
          }else if(selectedBaseSheetField.value.answer_texts.length > 0){
            changeSelectedStamp(selectedBaseSheetField.value.answer_texts[0], true);
            state.drawMode = DrawModeEnum.None;
          }
        }else{
          // 上記に当てはまらない場合はモードOFF
          state.drawMode = DrawModeEnum.None;
        }

        context.root.$nextTick(async () => {
          
          const baseElemId = `${state.direction}-${state.base_sheet.sheet_type}-${selectedBaseSheetField.value.id}-parent`;
          const imageAreaElemId = `answer-page-root-${state.direction}-${state.base_sheet.sheet_type}`;
          await scrollToSelectedField(baseElemId, imageAreaElemId);

          const baseElem = document.getElementById(baseElemId);

          let moveElem: HTMLElement = null;
          if(selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Choice){
            moveElem = document.getElementById("choice-box");
            if(baseElem && moveElem){
              const clientRect = baseElem.getBoundingClientRect();
              if(clientRect.left + moveElem.clientWidth > window.innerWidth - 20){
                state.choiceAreaLeft = window.innerWidth - moveElem.clientWidth - 20;
              }else{
                state.choiceAreaLeft = clientRect.left;
              }
              
              if(clientRect.top - moveElem.clientHeight - 10 < 0){
                state.choiceAreaTop = 10;
              }else{
                state.choiceAreaTop = clientRect.top - moveElem.clientHeight - 10;
              }
            }
          }else{
            moveElem = document.getElementById("kaitou-toolbox");
            if(baseElem && moveElem){
              const clientRect = baseElem.getBoundingClientRect();
              if(clientRect.left + moveElem.clientWidth > window.innerWidth){
                state.modeAreaLeft = window.innerWidth - moveElem.clientWidth - 20;
              }else{
                state.modeAreaLeft = clientRect.left;
              }
              
              if(clientRect.top - moveElem.clientHeight - 10 < 0){
                state.modeAreaTop = 10;
              }else{
                state.modeAreaTop = clientRect.top - moveElem.clientHeight - 10;
              }
            }
          }
        });
      }
    }

    /******************************
     * 設問切替時の自動スクロール
     ******************************/

    const scrollToSelectedField = async (targetElemId: string, parentElemId: string) => {

      const targetElem = document.getElementById(targetElemId);
      const parentElem = document.getElementById(parentElemId);

      if(!targetElem || !parentElem){
        return;
      }

      const parentElemWidth = parentElem.offsetWidth;
      const parentElemHeight = parentElem.offsetHeight;
      const parentElemTop = parentElem.scrollTop;
      const parentElemBottom = parentElemTop + parentElemHeight;
      const parentElemLeft = parentElem.scrollLeft;
      const parentElemRight = parentElem.scrollLeft + parentElemWidth;
      const targetElemTop = targetElem.offsetTop;
      const targetElemBottom = targetElem.offsetTop + targetElem.offsetHeight;
      const targetElemLeft = targetElem.offsetLeft;
      const targetElemRight = targetElem.offsetLeft + targetElem.offsetWidth;

      let fromTop = parentElemTop;
      let toTop = parentElemTop;
      let fromLeft = parentElemLeft;
      let toLeft = parentElemLeft;

      if(parentElemTop > targetElemTop || parentElemBottom < targetElemBottom){
        toTop = targetElemTop - (parentElemHeight / 3);
      }

      if(parentElemLeft > targetElemLeft || parentElemRight < targetElemRight){
        toLeft = targetElemLeft - (parentElemWidth / 3);
      }

      if(fromTop != toTop || fromLeft != toLeft){
        state.isScrolling = true;
        await Common.smoothScroll(fromTop, toTop, fromLeft, toLeft, parentElem);
        state.isScrolling = false;
      }
    }

    /************************************************************
     * 選択中の設問を返却
     ************************************************************/

    const selectedBaseSheetField = computed((): BaseSheetField => {
      if(state.selectedAnswerPageIdx != null && state.selectedFieldIdx != null){
        return state.pageItems[state.selectedAnswerPageIdx].base_sheet_fields[state.selectedFieldIdx];
      }else{
        return null;
      }
    });

    /************************************************************
     * テキスト解答可否
     ************************************************************/

    const isTextDrawable = computed((): boolean => {
      if(selectedBaseSheetField.value != null){
        return selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Both || selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Text || selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Image;
      }else{
        return true;
      }
    });

    /************************************************************
     * 手書き解答可否
     ************************************************************/

    const isCanvasDrawable = computed((): boolean => {
      if(selectedBaseSheetField.value != null){
        return selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Both || selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Draw || selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Image
      }else{
        return true;
      }
    });

    /************************************************************
     * 画像解答可否
     ************************************************************/

    const isImageDrawable = computed((): boolean => {
      if(selectedBaseSheetField.value != null){
        return selectedBaseSheetField.value.answer_type == Common.AnswerTypeEnum.Image;
      }else{
        return false;
      }
    });

    /************************************************************
     * 解答モードエリアの横幅
     ************************************************************/

    const modeAreaWidth = computed((): number => {
      let rtn = 0;
      if(isTextDrawable.value && isCanvasDrawable.value){
        rtn = 320;
      }else if(isTextDrawable.value){
        rtn = 120;
      }else if(isCanvasDrawable.value){
        rtn = 233;
      }
      return rtn;
    });

    /************************************************************
     * 採点モード切り替え AnserImageArea.vueからemitされる
     ************************************************************/
    
    const changeDrawMode = (drawMode: number) => {
      
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
      
      state.selectedStamp = null;
      if(state.drawMode == drawMode){
        state.drawMode = DrawModeEnum.None;
      }else{
        state.drawMode = drawMode;
      }
    }

    /************************************************************
     * 選択中のテキストスタンプ切り替え AnserImageArea.vueから呼ばれる
     ************************************************************/

    const changeSelectedStamp = (selectedStamp: any, isFocus: boolean = false) => {
      state.selectedStamp = selectedStamp;
      if(state.selectedStamp && state.selectedStamp.stamp_type == Common.StmapTypeEnum.Text){
        state.fontSize = selectedStamp.font_size;
        state.lineHeight = selectedStamp.line_height;
        state.textColor = selectedStamp.color;

        context.root.$nextTick(() => {
          const baseElem = document.getElementById(`${state.direction}-${state.base_sheet.sheet_type}-${selectedStamp.base_sheet_field_id}-${selectedStamp.idx}-text-stamp`);
          const moveElem = document.getElementById("text-edit-area");
          if(baseElem && moveElem){
            const clientRect = baseElem.getBoundingClientRect();
            if(clientRect.left + moveElem.clientWidth > window.innerWidth - 20){
              textEditBoxRef.value.textEditAreaLeft = window.innerWidth - moveElem.clientWidth - 20;
            }else{
              textEditBoxRef.value.textEditAreaLeft = clientRect.left;
            }
            
            if(clientRect.top - moveElem.clientHeight - 10 < 0){
              textEditBoxRef.value.textEditAreaTop = 10;
            }else{
              textEditBoxRef.value.textEditAreaTop = clientRect.top - moveElem.clientHeight - 10;
            }

            if(isFocus){
              const textarea = document.getElementById("text-edit-box-textarea");
              if(textarea){
                textarea.focus();
              }
            }
          }
        });
      }
    }

    /************************************************************
     * 設問中央にテキストスタンプ出力
     ************************************************************/

    const addTextStampFieldCenter = () => {
      // 選択肢の場合はテキスト追加しない
      if(selectedBaseSheetField.value.answer_type == Common.AnswerTypeEnum.Choice){
        return;
      }
      const size = Common.getTextSize({text: "", fontSize: state.fontSize, lineHeight: state.lineHeight, direction: context.root.$store.state.textDirection});
      const answerText = new AnswerText();
      answerText.base_sheet_field_id = selectedBaseSheetField.value.id;
      answerText.idx = selectedBaseSheetField.value.answer_text_idx++;
      answerText.font_size = state.fontSize;
      answerText.line_height = state.lineHeight;
      answerText.color = state.textColor;
      answerText.x = (selectedBaseSheetField.value.width + (state.fieldMargin * 2) - size.width) / 2;
      answerText.y = (selectedBaseSheetField.value.height + (state.fieldMargin * 2) - size.height) / 2;
      answerText.width = size.width;
      answerText.height = size.height;
      answerText.direction = context.root.$store.state.textDirection;
      answerText.base64_text = Common.createBase64Text(answerText);
      addTextStamp(answerText, true);
    }

    /************************************************************
     * テキストスタンプ追加
     * ツールバーのテキストボタン押下で選択設問の中央に出力する
     ************************************************************/

    const addTextStamp = (answerText: AnswerText, isFocus: boolean = false) => {
      selectedBaseSheetField.value.answer_texts.push(answerText);
      state.drawModeCache = DrawModeEnum.Text;
      changeSelectedStamp(answerText, isFocus);
    }

    /************************************************************
     * テキストスタンプ削除 AnserImageArea.vueから呼ばれる
     ************************************************************/

    const deleteTextStamp = (answerText: AnswerText) => {
      // 選択肢を表示するスタンプは削除しない
      if(selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Choice){
        return;
      }
      const idx = selectedBaseSheetField.value.answer_texts.indexOf(answerText);
      selectedBaseSheetField.value.answer_texts.splice(idx, 1);
      state.selectedStamp = null;
    }

    /************************************************************
     * 画像スタンプ削除
     ************************************************************/

    const deleteImageStamp = (imageStamp: any) => {
      const idx = selectedBaseSheetField.value.answer_images.indexOf(imageStamp);
      selectedBaseSheetField.value.answer_images.splice(idx, 1);
      state.selectedStamp = null;
    }

    const choiceAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 4;
      state.pointerOffsetY = e.offsetY + 10;
      state.isDragging = true;
    }

    const choiceAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.choiceAreaLeft = e.clientX - state.pointerOffsetX;
        state.choiceAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const choiceareaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    const choiceAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }
    
    const modeAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 4;
      state.pointerOffsetY = e.offsetY + 10;
      state.isDragging = true;
    }

    const modeAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.modeAreaLeft = e.clientX - state.pointerOffsetX;
        state.modeAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const modeAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const modeAreaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    const changeChoceText = (choice_text: string) => {
      // 未回答の場合、size.widthが0になる⇒0で画面に表示しようとするとスクリプトエラーになるので1を設定
      const size = choice_text ? Common.getTextSize({text: choice_text, fontSize: 32, lineHeight: 0, direction: selectedBaseSheetField.value.answer_texts[0].direction, defaultText: ""}) : new Common.Size(1, 1);
      const answerText = selectedBaseSheetField.value.answer_texts[0];
      answerText.text = choice_text;
      answerText.width = size.width ? size.width : 1;
      answerText.height = size.height;
      answerText.x = (selectedBaseSheetField.value.width + (state.fieldMargin * 2) - size.width) / 2;
      answerText.y = (selectedBaseSheetField.value.height + (state.fieldMargin * 2) - size.height) / 2;
      answerText.base64_text = Common.createBase64Text(answerText, "");
    }

    const changeChoiceTextDirection = (direction: number) => {
      const answerText = selectedBaseSheetField.value.answer_texts[0];
      answerText.direction = direction;
      const size = answerText.text ? Common.getTextSize({text: answerText.text, fontSize: 32, lineHeight: 0, direction: answerText.direction, defaultText: ""}) : new Common.Size(1, 1);
      answerText.width = size.width ? size.width : 1;
      answerText.height = size.height;
      answerText.x = (selectedBaseSheetField.value.width + (state.fieldMargin * 2) - size.width) / 2;
      answerText.y = (selectedBaseSheetField.value.height + (state.fieldMargin * 2) - size.height) / 2;
      answerText.base64_text = Common.createBase64Text(answerText, "");
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      const size = Common.getTextSize({text: state.selectedStamp.text, fontSize: state.selectedStamp.font_size, lineHeight: state.selectedStamp.line_height, direction: state.selectedStamp.direction});
      
      if(state.selectedStamp.direction == DirectionEnum.Vertical){
        let diffW = size.width - state.selectedStamp.width;
        state.selectedStamp.x -= diffW;
      }
      
      state.selectedStamp.width = size.width;
      state.selectedStamp.height = size.height;
      state.selectedStamp.base64_text = Common.createBase64Text(state.selectedStamp);
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間・カラー変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.selectedStamp.font_size = fontSize;
      state.selectedStamp.line_height = lineHeight;
      state.selectedStamp.color = textColor;
      const size = Common.getTextSize({text: state.selectedStamp.text, fontSize: fontSize, lineHeight: lineHeight, direction: state.selectedStamp.direction});

      if(state.selectedStamp.direction == DirectionEnum.Vertical){
        let diffW = size.width - state.selectedStamp.width;
        state.selectedStamp.x -= diffW;
      }

      state.selectedStamp.width = size.width;
      state.selectedStamp.height = size.height;
      state.selectedStamp.base64_text = Common.createBase64Text(state.selectedStamp);
    }


    /************************************************************
     * 最終操作キャッシュを設定
     ************************************************************/

    const setDrawModeCache = (drawMode: number) => {
      state.drawModeCache = drawMode;
    }

    /************************************************************
     * キー押下
     ************************************************************/

    const keyDown = (e:KeyboardEvent) => {

      // API通信中は処理しない
      if(!state.isShortcutKeyEnable){
        return;
      }

      // Shiftキー+ショートカットキー
      if(selectedBaseSheetField.value && e.shiftKey){

        if(e.key == "Enter" || e.key == "Backspace"){

          e.preventDefault();

          let fieldIdx: number = null;
        
          if(e.key == "Enter"){
            if(state.pageItems[state.selectedAnswerPageIdx].base_sheet_fields.length > state.selectedFieldIdx + 1){
              // 同ページ内の次設問を選択
              fieldIdx = state.selectedFieldIdx + 1;
            }else if(state.pageItems.length > state.selectedAnswerPageIdx + 1){
              // 次ページの先頭設問を選択
              state.selectedAnswerPageIdx++;
              fieldIdx = 0;
            }
          }else if(e.key == "Backspace"){
            if(state.selectedFieldIdx > 0){
              // 同ページ内の前設問を選択
              fieldIdx = state.selectedFieldIdx - 1;
            }else if(state.selectedAnswerPageIdx > 0){
              // 前ページの先頭設問を選択
              state.selectedAnswerPageIdx--;
              fieldIdx = state.pageItems[state.selectedAnswerPageIdx].base_sheet_fields.length - 1;
            }
          }

          if(fieldIdx != null){
            changeSelectedBaseSheetField(fieldIdx);
            return;
          }
        }
      }

      // 選択肢設問の矢印キーによる変更
      if(selectedBaseSheetField.value && selectedBaseSheetField.value.answer_type == AnswerTypeEnum.Choice){
        if(e.key == "ArrowRight"){
          // 次の設問
          const choiceText = selectedBaseSheetField.value.answer_texts[0].text;
          if(choiceText == null || choiceText == ""){
            changeChoceText(selectedBaseSheetField.value.choice_texts[0]);
          }else{
            const idx = selectedBaseSheetField.value.choice_texts.indexOf(choiceText);
            if(idx + 1 >= selectedBaseSheetField.value.choice_texts.length){
              changeChoceText("");
            }else{
              changeChoceText(selectedBaseSheetField.value.choice_texts[idx + 1]);
            }
          }
        }else if(e.key == "ArrowLeft"){
          // 前の設問へ移動
          const choiceText = selectedBaseSheetField.value.answer_texts[0].text;
          if(choiceText == null || choiceText == ""){
            changeChoceText(selectedBaseSheetField.value.choice_texts[selectedBaseSheetField.value.choice_texts.length - 1]);
          }else{
            const idx = selectedBaseSheetField.value.choice_texts.indexOf(choiceText);
            if(idx == 0){
              changeChoceText("");
            }else{
              changeChoceText(selectedBaseSheetField.value.choice_texts[idx - 1]);
            }
          }
        }
      }

      // 以降のショートカットはtextareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      // Shiftキー+ショートカットキー
      if(selectedBaseSheetField.value && e.shiftKey){

        let isShortcutExecuted = false;

        if(e.key == "T" && isTextDrawable.value){
          // テキストスタンプ追加
          addTextStampFieldCenter();
          state.drawMode = DrawModeEnum.None;
          isShortcutExecuted = true;
        }else if(e.key == "D" && isTextDrawable && selectedBaseSheetField.value.answer_texts.length > 0){
          // テキストスタンプ削除(選択中設問の最後のテキストスタンプ)
          // const targetTextStamp = selectedBaseSheetField.value.answer_texts[selectedBaseSheetField.value.answer_texts.length - 1];
          // deleteTextStamp(targetTextStamp);
          // isShortcutExecuted = true;
        }else if(e.key == "I" && isImageDrawable.value){
          // 画像スタンプ追加
          // 一時的な <input type="file"> を生成
          const input = document.createElement("input");
          input.type = "file";

          // ファイル選択後の処理
          input.addEventListener("change", (event: any) => {
            addAnswerImage(event);
          });

          // クリックイベントを発火して画像選択ダイアログ表示
          input.click();
          isShortcutExecuted = true;
        }

        if(isShortcutExecuted){
          e.preventDefault();
          return;
        }
      }

      if(e.key == "Backspace" && selectedBaseSheetField.value && selectedBaseSheetField.value.answer_type != AnswerTypeEnum.Choice && state.selectedStamp != null){
        if(state.selectedStamp.stamp_type == Common.StmapTypeEnum.Text){
          const idx = state.pageItems[state.selectedAnswerPageIdx].base_sheet_fields[state.selectedFieldIdx].answer_texts.indexOf(state.selectedStamp);
          state.pageItems[state.selectedAnswerPageIdx].base_sheet_fields[state.selectedFieldIdx].answer_texts.splice(idx, 1);
        }else if(state.selectedStamp.stamp_type == Common.StmapTypeEnum.Image){
          const idx = state.pageItems[state.selectedAnswerPageIdx].base_sheet_fields[state.selectedFieldIdx].answer_images.indexOf(state.selectedStamp);
          state.pageItems[state.selectedAnswerPageIdx].base_sheet_fields[state.selectedFieldIdx].answer_images.splice(idx, 1);
        }
        
        state.selectedStamp = null;
      }

      // テキスト不可の場合のTショートカットは無効
      if(isTextDrawable.value && e.key == "t"){
        state.keyCode = e.key;
      }

      // 手書き不可の場合のD/Eショートカットは無効
      if(isCanvasDrawable.value && (e.key == "d" || e.key == "e")){
        state.keyCode = e.key;
      }
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyUp = (e: KeyboardEvent) => {
      state.keyCode = "";
    }

    /************************************************************
     * ショートカットキー＋マウスダウンによる解答モード変更
     ************************************************************/

    const changeDrawModeFromChild = (drawMode: number) => {
      state.drawMode = drawMode;
    }

    /************************************************************
     * ピンチインアウトによる画面の拡大縮小禁止処理
     ************************************************************/

    const rootTouchmove = (e: TouchEvent) => {
      if(e.touches.length > 1){
        e.preventDefault();
      }
    }

    /************************************************************
     * 画像スタンプ追加
     ************************************************************/
    const addAnswerImage = (event: any) => {
      
      state.drawMode = DrawModeEnum.None;

      // var files = context.root.$store.state.isMobile ? event.target.files : event.dataTransfer.files;
      const files = event.target.files;

      if(files.length > 1){
        alert("複数ファイルは選択できません。");
        return;
      }

      // 拡張子チェック
      const extentions = ["jpg", "jpeg", "heic", "png"];
      const file_work = files[0].name.split('.');
      const extention = file_work[file_work.length - 1].toLowerCase();
      if(!extentions.includes(extention)) {
        alert(`選択可能なファイルは[${extentions}]です。`);
        return;
      }

      if(extention == "heic"){
        heic2any({
          blob: files[0],
          toType: 'image/jpeg',
          quality: 1.0
        })
        .then((conversionResult: any) => {
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = URL.createObjectURL(conversionResult);
        })
        .catch(function(error) {
          console.error(error);
        });
      }else{
        const reader  = new FileReader();
        reader.onload = (e) => {        
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = e.target?.result as string;
        };
        reader.readAsDataURL(files[0]);
      }

      event.target.value = "";
    };

    /************************************************************
     * 画像ファイルロード後
     ************************************************************/

    const imageLoaded = (img: HTMLImageElement, extention: string) => {
      const imageType = extention == "png" ? "image/png" : "image/jpeg"
      let width = img.width;
      let height = img.height;

      let scale = 1;
      const scaleW = (selectedBaseSheetField.value.width - 20) / img.width;
      const scaleH = (selectedBaseSheetField.value.height - 20) / img.height;

      if(scaleW > scaleH){
        // scale = scaleH > 1 ? 1 : scaleH;
        scale = scaleH;
      }else{
        // scale = scaleW > 1 ? 1 : scaleW;
        scale = scaleW
      }

      width *= scale;
      height *= scale;

      // 画像をcanvasに描画した後にbase64文字列に変換
      const canvas = document.createElement("canvas") as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      ctx?.drawImage(img, 0, 0, width, height);
      const base64 = canvas.toDataURL(imageType, 1.0).replace(`data:${imageType};base64,`, "");

      const answerImage = new AnswerImage();
      answerImage.base_sheet_field_id = selectedBaseSheetField.value.id;
      answerImage.idx = selectedBaseSheetField.value.answer_image_idx++;
      answerImage.x = state.fieldMargin + 10;
      answerImage.y = state.fieldMargin + 10;
      answerImage.width = width * 0.5;
      answerImage.height = height * 0.5;
      answerImage.base64_image = base64;
      selectedBaseSheetField.value.answer_images.push(answerImage);
    }

    /************************************************************
     * 残り時間・画面表示用文字列
     ************************************************************/

    const remainingTimeText = computed((): string => {
      // ミリ秒からdurationオブジェクトを生成
      const duration = moment.duration(state.remainingTime);
      
      // 日・時・分・秒を取得
      const days = Math.floor(duration.asDays());
      const hours   = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      // カウントダウンの結果を変数に代入
      if(days > 0){
        return '残り時間：' + days + '日' +  hours + '時間' + minutes + '分' + seconds + '秒';
      }else if(hours > 0){
        return '残り時間：' +  hours + '時間' + minutes + '分' + seconds + '秒';
      }else if(minutes > 0){
        return '残り時間：' +  minutes + '分' + seconds + '秒';
      }else{
        return '残り時間：' +  seconds + '秒';
      }
    });

    /************************************************************
     * 残り時間・画面表示用文字列
     ************************************************************/

    const timeOverAlertText = computed(() => {
      return state.base_sheet ? `${Common.formatDate(state.base_sheet.final_deadline_at, "k時m分に試験が終了します")}` : "";
    });

    /************************************************************
     * 解答の編集可否
     ************************************************************/

    const isEditable = computed((): any => {
      return state.currentMode == CurrentModeEnum.Answer && !state.isTimeOver && !state.isParent;
    });

    /************************************************************
     * 提出可否
     ************************************************************/

     const isSubmittable = computed((): any => {
      return state.currentMode == CurrentModeEnum.Answer && (!state.isTimeOver || context.root.$store.getters.isOptionAllowSubmitOverLimitActive) && !state.isParent;
    });

    /************************************************************
     * ツールバー表示位置切替
     ************************************************************/

    const toolbarPositionChanged = (position: number) => {
      state.toolbarPosition = position;
      context.root.$store.commit("setKaitouToolbarPosition", state.toolbarPosition);
      context.root.$nextTick(() => {
        adjustHeight();
      });
    }

    /************************************************************
     * 保存
     ************************************************************/

    const save = async () => {

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      let baseSheetFields = new Array<BaseSheetField>();
      state.pageItems.forEach(x => baseSheetFields = baseSheetFields.concat(x.base_sheet_fields));

      // canvas・解答文字画像をZip化
      let zip = new jsZip();
      baseSheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.base_sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
        x.answer_images.forEach(y => {
          zip.file(`answer_image_${y.base_sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
        });
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("base_sheet_id", state.base_sheet.id.toString());
        fd.append("student_code", context.root.$store.state.student_code);
        fd.append("times", state.times.toString());
        fd.append("param_base_sheet_fields", JSON.stringify(baseSheetFields.map(x => new ParamBaseSheetField(x))));

        await http.post(`/api/student/digital_report/save`, fd).then(response => {
          //alert("保存処理が完了しました。");
          saveCompletedToastRef.value.show();
          state.errors = [];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * 提出
     ************************************************************/

    const entry = async () => {

      if(context.root.$store.getters.isStudent && state.movieContents.length > 0){
        let isMovieCompleted = true;

        await http.get(`/api/student/digital_report/check_movie_complete?base_sheet_id=${state.base_sheet.id}`).then(response => {
          isMovieCompleted = response.data.all_completed;
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
          isMovieCompleted = false;
        });

        if(state.errors.length > 0){
          return;
        }

        if(!isMovieCompleted){
            alert("動画視聴が完了していないため提出できません。");
            return;
        }
      }

      if(!window.confirm("デジタルレポートを提出します。よろしいですか？")){
        return;
      }

      let baseSheetFields = new Array<BaseSheetField>();
      state.pageItems.forEach(x => baseSheetFields = baseSheetFields.concat(x.base_sheet_fields));

      if(baseSheetFields.filter(x => !x.isKaitouCompleted).length > 0){
        if(!window.confirm("未解答の設問がありますが、提出してよろしいですか？")){
          return;
        }
      }

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      // canvas・解答文字画像をZip化
      let zip = new jsZip();
      baseSheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.base_sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
        x.answer_images.forEach(y => {
          zip.file(`answer_image_${y.base_sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
        });
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("base_sheet_id", state.base_sheet.id.toString());
        fd.append("student_code", context.root.$store.state.student_code);
        fd.append("times", state.times.toString());
        fd.append("param_base_sheet_fields", JSON.stringify(baseSheetFields.map(x => new ParamBaseSheetField(x))));

        await http.post(`/api/student/digital_report/entry`, fd).then(response => {
          alert("処理が完了しました。");
          state.errors = [];
          window.history.back();
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }
      
      if(!Common.studentSiteLoginCheck(context)){
        return;
      }

      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      const subject_code = context.root.$route.params.subject_code;
      const nendo = context.root.$route.params.nendo;
      const report_no = context.root.$route.params.report_no;
      state.times = context.root.$route.params.times ? Number(context.root.$route.params.times) : 1;
      state.currentMode = context.root.$store.state.is_preview_mode ? CurrentModeEnum.Preview : CurrentModeEnum.Answer;

      let paramStr = `subject_code=${subject_code}&nendo=${nendo}&report_no=${report_no}&student_code=${context.root.$store.state.student_code}&is_preview_mode=${context.root.$store.state.is_preview_mode}`;
      paramStr += state.times ? `&times=${state.times}` : "";

      await http.get(`/api/student/digital_report?${paramStr}`).then(response => {
        state.base_sheet = new BaseSheet(response.data.base_sheet);
        state.subject_name = response.data.subject_name;
        state.status = response.data.status;
        state.base64QuestionImages = response.data.base64_question_images;
        state.before_student_sheet_id = response.data.before_student_sheet_id;
        state.fieldMargin = response.data.cut_margin;
        state.scored_user_name = response.data.scored_user_name;
        state.questionImageDiscriptions = response.data.question_image_discriptions;
        state.rejectionStudentSheetLog = response.data.rejection_student_sheet_log;
        state.movieContents = response.data.movie_contents;

        // 同一レポートマスタを使用した再提出の場合、前回の採点結果を設問へ設定
        response.data.before_scoring_results.forEach((beforeScoringResult: any) => {
          const baseSheetField = response.data.base_sheet_fields.find((x: any) => x.id == beforeScoringResult.base_sheet_field_id);
          if(baseSheetField){
            baseSheetField.before_correct_state = beforeScoringResult.correct_state;
            baseSheetField.before_score = beforeScoringResult.score;
            baseSheetField.before_sheet_field_mark = beforeScoringResult.sheet_field_mark;
          }
        });

        for(let i = 0; i < state.base_sheet.page_count; i++){
          state.pageItems.push(new PageItem(i + 1, response.data.base64_answer_images[i], response.data.base_sheet_fields, state.base_sheet.width, state.base_sheet.height, response.data.answer_image_discriptions));
        }
        
        // メッセージありの場合はアラート表示
        if(response.data.message){
          alert(response.data.message);
        }

        // 問題用紙・動画の表示設定
        const previewImateTypes: number[] = [];
        if(state.movieContents.length > 0){
          previewImateTypes.push(PreviewImageTypeEnum.Movie);
        }
        if(state.base64QuestionImages.length > 0){
          previewImateTypes.push(PreviewImageTypeEnum.Question);
        }
        state.previewImateTypes = previewImateTypes;
        state.previewImageType = previewImateTypes.length > 0 ? previewImateTypes[0] : PreviewImageTypeEnum.None;

        state.pcHelpFields.push({ key: "Tキー + クリック", img: [require("@/assets/images/keyboard_T.png")], description: "テキスト出力" });
        state.pcHelpFields.push({ key: "テキスト選択中にBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中のテキスト削除" });
        state.pcHelpFields.push({ key: "Dキー + マウス", img: [require("@/assets/images/keyboard_D.png")], description: "自由線" });
        state.pcHelpFields.push({ key: "Eキー + マウス", img: [require("@/assets/images/keyboard_E.png")], description: "消しゴム" });
        state.pcHelpFields.push({ key: "Ctrlキー + マウスホイール", img: [require("@/assets/images/keyboard_Ctrl.png")], description: "拡大縮小" });
        state.pcHelpFields.push({ key: "Shiftキー + マウスホイール", img: [require("@/assets/images/keyboard_Shift.png")], description: "左右にスクロール" });
        state.pcHelpFields.push({ key: "Shiftキー + エンターキー", img: [require("@/assets/images/keyboard_Shift.png"), require("@/assets/images/keyboard_Enter.png")], description: "次の設問に移動" });
        state.pcHelpFields.push({ key: "Shiftキー + BackSpace", img: [require("@/assets/images/keyboard_Shift.png"), require("@/assets/images/keyboard_Backspace.png")], description: "前の設問に移動" });
        state.pcHelpFields.push({ key: "Shiftキー + Tキー", img: [require("@/assets/images/keyboard_Shift.png"), require("@/assets/images/keyboard_T.png")], description: "テキスト出力" });
        // state.pcHelpFields.push({ key: "Shiftキー + Dキー", img: [require("@/assets/images/keyboard_Shift.png"), require("@/assets/images/keyboard_D.png")], description: "テキスト削除" });
        if(response.data.base_sheet_fields.find((x: any) => x.answer_type == AnswerTypeEnum.Image)){
          state.pcHelpFields.push({ key: "Shiftキー + Iキー", img: [require("@/assets/images/keyboard_Shift.png"), require("@/assets/images/keyboard_I.png")], description: "画像出力" });
        }
        if(response.data.base_sheet_fields.find((x: any) => x.answer_type == AnswerTypeEnum.Choice)){
          state.pcHelpFields.push({ key: "選択肢設問で右矢印キー", img: [require("@/assets/images/keyboard_Arrow_Right.png")], description: "次の選択肢に移動" });
          state.pcHelpFields.push({ key: "選択肢設問で左矢印キー", img: [require("@/assets/images/keyboard_Arrow_Left.png")], description: "前の選択肢に移動" });
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        window.history.back();
      });

      state.initiarizedData = true;
      context.root.$nextTick(() => {
        adjustHeight();
        adjustSheet();

        // プレビューでも保護者でもない＝生徒本人の解答モード        
        if(!context.root.$store.state.is_preview_mode && !state.isParent){
          
          // 先頭の設問を選択状態にする
          changeSelectedBaseSheetField(0);
          
          if(isCanvasDrawable.value){
            // 手書き可能な設問の場合、初期モードで自由線を設定
            state.drawMode = DrawModeEnum.FreeLine;
            state.drawModeCache = DrawModeEnum.FreeLine;
          }else if(isTextDrawable.value){
            // テキストのみの設問の場合、中央にテキストを出力
            addTextStampFieldCenter();
          }
        }
      });
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("orientationchange", adjustHeight);
      window.addEventListener("keyup", keyUp);
      window.addEventListener("keydown", keyDown);
      document.body.style.overflow = "hidden";

      // 終了日時が設定されている場合はタイマー起動
      if(state.base_sheet.final_deadline_at && !state.isParent){
        state.timer = setInterval(async () => {

          // 現在日時取得
          var now = Date.now();

          // テスト終了日時から現在日時を減算し、残り時間を求める
          state.remainingTime = (state.base_sheet.final_deadline_at.getTime() - now);

          // 残り時間があるか判定
          if(!state.isTimeOver && state.remainingTime <= 0){
            // 解答操作をOFFにする
            state.isTimeOver = true;
            state.isRemainingTimeDisp = false;
            state.isTimeOverAlertDisp = false;
            state.selectedFieldIdx = null;
            state.selectedStamp = null;

            // タイマー停止
            clearInterval(state.timer);

            if(context.root.$store.getters.isOptionAllowSubmitOverLimitActive){
              // 締切後提出を許可している場合
              alert("レポートの最終締切日時を超過しました。");
            }else{
              // 締切後提出不可の場合
              alert("レポートの提出は締め切られました。");
            }
            
          }else if(!state.isRemainingTimeDisp && state.remainingTime < 1 * 60 * 1000){
            // 残り1分でタイマー表示
            state.isRemainingTimeDisp = true;
          }else if(!state.isTimeOverAlertDisp && state.remainingTime < 5 * 60 * 1000){
            // 残り5分で終了間近のお知らせ表示
            state.isTimeOverAlertDisp = true;
          }
        }, 200);
      }

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("orientationchange", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.overflow = "";
      if(state.timer){
        clearInterval(state.timer);
      }
    });

    return {
      ...toRefs(state),
      DrawModeEnum,
      StmapTypeEnum,
      ToolbarPositionEnum,
      PreviewImageTypeEnum,
      AnswerTypeEnum,
      horizonAnswerImageAreaRef,
      verticalAnswerImageAreaRef,
      horizonCorrectImageAreaRef,
      verticalCorrectImageAreaRef,
      horizonQuestionImageAreaRef,
      verticalQuestionImageAreaRef,
      saveCompletedToastRef,
      textEditBoxRef,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      horizonModeTopHeight,
      horizonModeBottomHeight,
      changeDirection,
      answerSheetPageChanged,
      questionSheetPageChanged,
      correctImagePageChanged,
      changeImageType,
      changeSelectedBaseSheetField,
      selectedBaseSheetField,
      save,
      entry,
      changeDrawMode,
      changeSelectedStamp,
      addTextStamp,
      deleteTextStamp,
      changeText,
      textFormatChanged,
      choiceAreaHeaderPointerDown,
      choiceAreaHeaderPointerMove,
      choiceAreaHeaderPointerUp,
      choiceareaTouchMove,
      modeAreaHeaderPointerDown,
      modeAreaHeaderPointerMove,
      modeAreaHeaderPointerUp,
      modeAreaTouchMove,
      downloadResultPdf,
      keyDown,
      keyUp,
      changeDrawModeFromChild,
      rootTouchmove,
      isTextDrawable,
      isCanvasDrawable,
      isImageDrawable,
      modeAreaWidth,
      remainingTimeText,
      timeOverAlertText,
      isEditable,
      isSubmittable,
      changeChoceText,
      changeChoiceTextDirection,
      addAnswerImage,
      deleteImageStamp,
      adjustHeight,
      toolbarPositionChanged,
      setDrawModeCache,
      addTextStampFieldCenter,
     };
  }
})
